import * as React from "react";
import {Button as MuiButton} from "@mui/material";
import "./button.scss";
import Loader from "../loader/loader";

interface ButtonProps {
    text: string;
    onClick?: (event: any) => void;
    testId?: string;
    type: "primary" | "secondary";
    isWaiting?: boolean;
    disabled?: boolean;
    variant?: "contained" | "text" | "outlined";
    endIcon?: JSX.Element;
    startIcon?: JSX.Element;
    className?: string | "";
}

export default function Button(props: ButtonProps): React.ReactElement {
    const typeClass = props.type === "primary" ? "primary" : "secondary";
    const withLoader = props.isWaiting ? "with-loader" : "";
    const disabled = props.disabled ? "disabled" : "";
    const className = props.className ? props.className : "";

    return (
        <MuiButton
            variant={props.variant || "contained"}
            className={`button ${className} ${typeClass} ${withLoader} ${disabled}`}
            onClick={props.onClick}
            data-testid={props.testId}
            disabled={props.isWaiting || props.disabled}
            startIcon={props.startIcon}
            endIcon={props.endIcon}
        >
            {props.isWaiting ? <Loader/> : props.text}
        </MuiButton>
    );
}
